import { useAuth } from '@workos-inc/authkit-react';
import { useEffect } from 'react';
import { useAuthActions } from './auth-actions.hook';

export const useAuthInitEffect = () => {
  const { isLoading, user } = useAuth();
  const { signIn } = useAuthActions();

  useEffect(() => {
    if (!isLoading && !user) {
      signIn();
    }
  }, [isLoading, signIn, user]);

  return {
    isLoading: isLoading || !user
  };
};
